
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.container{
  display:flex;
  flex-direction:column;
  position:relative;
  z-index:1;
  padding:var(--spacing-4) var(--spacing-4);
}

.content-wrapper{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-4);
}

.figure-cta-container{
  display:flex;
  flex:1;
  flex-direction:column;
  align-items:center;
  justify-content:center;
}

.figure{
  margin-bottom:var(--spacing-4);
  max-width:250px;
}

.content{
  display:flex;
  flex-direction:column;
  justify-content:center;
}

.heading{
  --heading-color:var(--brand-dark-blue-900);
}

.body{
  margin-bottom:var(--spacing-6);
}

@media (min-width: 768px){
  .content-wrapper{
    flex-direction:row;
    flex-wrap:nowrap;
  }
  .content{
    flex:1;
    justify-content:flex-start;
  }
}

@media (min-width: 1024px){
  .content{
    flex:2;
  }
}
`;